export default ({ to }: { to: string }): string => to;
